<template>
    <div class="CSChatThai" style="background: #2562af;">
     <div style="background: #2562af !important; padding: 10px;">

  <v-btn icon @click="goback()" style="margin: 0 !important;">
        <v-icon class="white--text" style="font-size: 24px;">chevron_left</v-icon>
      </v-btn>
 

 <span style="color: white;font-weight: 800; margin-left: 25vw;">สร้างกลุ่ม</span>
    <span :class="'okBTN'" v-if="state=='second'" @click="skipuploadPic()">ข้าม</span>
      <span :class="(checkEnabledCreateGroup())? 'okBTN':'okBTNFalse'" v-else @click="createGroup()">ยืนยัน</span>
</div>






<div style="padding: 10px; cursor: pointer;background: #fafafa;">



   <div style="display: flex;justify-content: center;" v-if="state=='second'">
      <div class="image-upload">
    <v-img
            
            class="grey lighten-2 imageProfile alligator-turtle"
            @click="uppic"
          >
          </v-img>



      <label for="file-input" class="SettingImgBtn">
    เพิ่มรูป
  </label>

  <input id="file-input" type="file" @change="previewImageprofiles" accept="image/*"/>
</div>
      </div>






<v-layout row wrap v-else>
 <v-flex xs12 xl12 lg12 md12 sm12 style="margin-bottom: 5px;">
  <p class="colorHeader" >ชื่อกลุ่ม</p>
  <v-text-field
              solo
              placeholder="ตั้งชื่อกลุ่ม"
              counter="40"
              height="35"
              v-model="nameGroup"
              @input="searchUser()" ></v-text-field>
</v-flex>

<v-flex xs12 xl12 lg12 md12 sm12 style="margin-bottom: 5px !important;">
<p class="colorHeader" v-if="selectedMember.length">สมาชิก</p>
<div style="overflow-x: scroll;white-space: nowrap;">
<v-avatar size="40" color="#2562af" style="margin-right: 5px;" v-for="(v,index) in selectedMember" @click="detailAccount(v)">
      <img :src="backend + v.profile_picture" v-if="v.profile_picture" />
      <span class="headline white--text" v-else>
      {{(v['display_name'].length>=2)? v['display_name'].charAt(0)+v['display_name'].charAt(1):v['display_name'].charAt(0)}}</span>
      </v-avatar>
</div>
    




  </v-flex>


  <v-flex xs12 xl12 lg12 md12 sm12>
      <v-text-field
              solo
              placeholder="ค้นหาเพื่อน"
              prepend-inner-icon="fas fa-search"
              hide-details
              height="35"
              v-model="searchText"
              @input="searchUser()"
            ></v-text-field>


    </v-flex>
      <v-flex xs12 xl12 lg12 md12 sm12>






<div v-if="stateSearch">

      <v-list two-line style="height: 40vh;overflow: scroll;margin-top: 10px;" v-if="listUser.length > 0">
    <template v-for="(item, index) in listUser" >

      <v-list-tile avatar @click="toggleSelectMember(item)">
        <v-list-tile-avatar color="#2562af" size="40">
            <span class="white--text headline" v-if="!item.profile_picture">
            <!-- {{item['display_name'].charAt(0)}} -->
            {{(item['display_name'].length>=2)? item['display_name'].charAt(0)+item['display_name'].charAt(1):item['display_name'].charAt(0)}}
          </span>
            <img :src="backend + item.profile_picture" v-else />
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title class="CSChatThai" style="font-weight: 600;" v-text="item['display_name']"></v-list-tile-title>
          <v-list-tile-sub-title class="CSChatThai" v-text="item['email']"></v-list-tile-sub-title>
        </v-list-tile-content>

        <v-list-tile-action>
                  <v-icon v-if="!checkMemberIn(item)" color="grey lighten-1" >
                    radio_button_unchecked
                  </v-icon>
  
                  <v-icon v-else style="color: #00abffcf !important;font-size: 17px;" >
                    radio_button_checked
                  </v-icon>
                </v-list-tile-action>




      </v-list-tile>

      <v-divider v-if="index != listUser.length -1"></v-divider>
    </template>
  </v-list>

     <p v-else-if="searchText.length < 3" style="text-align: center;
    margin-top: 10px;">
    ต้องค้นหาตั้งแต่ 3 ตัวอักษรขึ้นไป
  </p>
  <p v-else style="text-align: center;
    margin-top: 10px;">
    ไม่พบเพื่อนที่ต้องการค้นหา
  </p>
  </div>
  <p v-else style="text-align: center;
    margin-top: 10px;">
    ค้นหาเพื่อนของคุณ จากอีเมลหรือชื่อ
  </p>


  </v-flex>
    
  </v-layout>
  </div>






    </div>
</template>

<script>
import gql from 'graphql-tag'
import { sync } from 'vuex-pathify'
import { Momenttime, Decode, Encode } from '@/services'
const SUB_LIST_ROOM = gql`
subscription ($user_id: uuid!) {
  list_chat(where: {user_id: {_eq: $user_id}}, order_by: {last_message_time: desc_nulls_last}) {
    room_id
    last_message_time
    last_message
    count_not_read
    room_type
    room_name
    friend_display_name
    status
  }
}`

const SET_TIME_READ = gql`
mutation ($user_id: uuid!, $room_id: uuid!) {
  update_member(where: {room_id: {_eq: $room_id}, _and: {user_id: {_eq: $user_id}}}, _set: {time_read: "now()"}) {
    returning {
      time_read
      room_id
      member_id
    }
  }
}
`

const SUB_USER_ONLINE = gql`
subscription ($user_id: uuid!) {
  user_online(order_by: {display_name: asc}, where: {user_id: {_neq: $user_id}}) {
    user_id
    username
    display_name
  }
}
`


export default {
  data: () => ({
    selectedMember: [],
    user_id: '',
    Authorization: {},
    searchText: '',
    nameGroup: '',
    backend: process.env.VUE_APP_API,
    listUser: [],
    selectFile: {},
    state: 'first',
    stateSearch: false
  }),
  apollo: {
    
  },
  computed: {
    ...sync('*')
  },
  created () {
    // this.$session.set('user_id', Encode.encodeToken('eeb8855b-b330-4bc5-a1d1-e7f3c3350277'))
    this.user_id = Decode.decodeToken(localStorage.getItem('user_id'))
    this.Authorization = {headers: {'Authorization': 'Bearer ' + Decode.decodeToken(localStorage.getItem('auth_token'))}}
  },
  methods: {
    previewImageprofiles (data) {
      this.selectFile = data.target.files[0]
      var uploadFile = new FormData()
      uploadFile.append('file', this.selectFile, this.selectFile.name)
      uploadFile.append('room_id', this.room_id)
      this.axios.post(process.env.VUE_APP_API + '/updateGroupPictureNoSystem', uploadFile, this.Authorization).then((response) => {
        if (response.data.message === 'success') {
          this.$router.push('/chat_room?id=' + response.data.data.room_id)
          this.setTimeRead(response.data.data.room_id)
        }
      })
    },
    skipuploadPic () {
      this.$router.push('/chat_room?id=' + this.room_id)
      this.setTimeRead(this.room_id)
    },
    // uploadpictureGroup () {
    //   var uploadFile = new FormData()
    //   uploadFile.append('file', this.selectFile, this.selectFile.name)
    //   uploadFile.append('room_id', this.room_id)
    //   this.axios.post(process.env.VUE_APP_API + '/updateGroupPictureNoSystem', uploadFile, this.Authorization).then((response) => {
    //     if (response.data.message === 'success') {
    //       // console.log(response.data.data.url)
    //       this.my_picture_Group = response.data.data.url
    //       // this.getDetail()
    //     }
    //   })
    // },
    uppic () {
      $('#file-input').click()
    },
    createGroup () {
      // console.log('group')
      if(this.checkEnabledCreateGroup()){
        var reqestBody = {group_name: this.nameGroup, group_member: _.map(this.selectedMember,'email')}
        this.axios.post(process.env.VUE_APP_API + '/createGroup', reqestBody, this.Authorization).then((response) => {
          this.room_id = response.data.data.room_id
          this.state = 'second'
          this.$swal('', 'สร้างกลุ่มสำเร็จ', 'success')
          // if (this.selectFile) {
          //   this.uploadpictureGroup()
          //   this.$router.push('/chat_room?id=' + response.data.data.room_id)
          //   this.setTimeRead(response.data.data.room_id)
          // } else {
          //   this.$router.push('/chat_room?id=' + response.data.data.room_id)
          //   this.setTimeRead(response.data.data.room_id)
          // }
        })
      }
    },
    checkEnabledCreateGroup () {
      return (this.selectedMember.length && this.nameGroup && this.nameGroup.length<=40)? true:false
    },
    checkMemberIn (item) {
      // this.selectedMember
      // console.log(item)
      // console.log(item.username)
      // console.log(_.find(this.selectedMember, { 'username': item.username}))
      if (_.find(this.selectedMember, { 'username': item.username})) {
        return true
      } else {
        return false
      }
    },
    toggleSelectMember (item) {
      // console.log(item)
      // console.log(!_.find(this.selectedMember, { 'username': item.username}))
      if (!_.find(this.selectedMember, { 'username': item.username})) {
        this.selectedMember.push(item)
        this.selectedMember = _.unionBy(this.selectedMember, 'username')
      } else {
        // console.log('clear')
        // this.selectedMember.push(item)

        var index = _.findIndex(this.selectedMember, function (o) { return o.username === item.username })
        if (index >= 0) {
          this.selectedMember.splice(index, 1)
        }
      }
    },
    selectRoom_userOnline(user_id) {
      var reqestBody = {
        "user_id": this.user_id,
        "username_friend": user_id
      }
      this.axios.post(process.env.VUE_APP_API + '/createRoomByEmail', reqestBody, this.Authorization).then((response) => {
        this.$router.push('/chat_room?id=' + response.data.data.room_id)
        this.setTimeRead(response.data.data.room_id)
      })
    },
    searchUser () {
      // console.log('searchUser')
      this.stateSearch = true
      if (this.searchText.length >= 3) {
        var reqestBody = { email: this.searchText, onemail_token: Decode.decodeToken(localStorage.getItem('onemail_token'))}
        this.axios.post(process.env.VUE_APP_API_v2 + '/searchFriend', reqestBody, this.Authorization).then((response) => {
          // console.log(response.data)
          this.listUser = response.data
        })
      } else if (this.searchText.length == 0) {
        this.stateSearch = false
      }
    },
    detailAccount (account) {
      console.log(account)
    },
    // time (timestamp) {
    //   return Momenttime.momenttimethaiformnow(timestamp)
    // },
    // setRoomName(room) {
    //   if (room.room_type == 'user') {
    //     return room.friend_display_name
    //   }
    //   return room.room_name
    // },
    // setLastMessage(room) {
    //   if (room.last_message) {
    //     return room.last_message.text
    //   } 
    //   return ''
    // },
    selectRoom(room) {
      this.setTimeRead(room.room_id)
      this.$router.push('/chat_room?id=' + room.room_id)
    },
    setTimeRead(room_id) {
      this.$apollo.mutate({
        mutation: SET_TIME_READ,
        variables: {
          user_id: this.user_id,
          room_id: room_id
        }
      })
    },
    goback () {
      this.$router.back()
    }
  }
    
} 
</script>
<style type="text/css" scoped>
.CSChatThai {
 /*font-family: 'CS ChatThaiUI' !important;*/
 word-wrap: break-word;
}
>>>.v-text-field--solo input {
    margin: auto !important;
    margin-top: auto !important;
}
>>>.v-text-field--solo>.v-input__control>.v-input__slot {
    /*background: white !important;
    border-radius: 10px !important;*/
    background: #3978c7 !important;
    border-radius: 38px !important;
}

>>>.v-input input:focus .v-text-field .v-input__prepend-inner {
  color: red;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  box-shadow: none;
  font-size: 15px;
}
.colorAvatar {
  color: #2562af !important;
}
.timeListChat {
  color: #adadad;
  font-size: 10px;
}
>>>.theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
  border: 0 !important;
}

>>>.v-badge--bottom .v-badge__badge {
  /*bottom: -8px !important;*/
  border: #2562af 2px solid !important;
  bottom: -6px !important;
}
>>>.v-badge__badge {
  height: 14px !important;
  width: 14px !important;
  right: -16px !important;
}
>>>.v-list--two-line .v-list__tile {
  height: 65px !important;
}
.v-text-field--box .v-input__slot, .v-text-field--solo .v-input__slot {
  height: 30px;
}
.defaultPicOnline {
  margin-right: 5px;
  cursor: pointer;
  background: white;
}

>>>.v-text-field--solo input {
  margin: auto !important;
  margin-top: auto !important;
  padding: 10px !important;
}
>>>.v-text-field--solo>.v-input__control>.v-input__slot {
    /*background: white !important;
    border-radius: 10px !important;*/
    background: #f3f3f3 !important;
    border-radius: 38px !important;
}

>>>.v-input input:focus .v-text-field .v-input__prepend-inner {
  color: red;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  box-shadow: none;
}
>>>.theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
  border: 0 !important;
}
>>>.v-input__icon .v-input__icon--prepend-inner .v-icon {
  font-size: 13px !important;
}
>>>.v-icon {
    font-size: inherit;
  }

  >>>.v-list--two-line .v-list__tile {
  height: 65px !important;
}

.theme--light.v-list {
    background: #fafafa;
    color: rgba(0,0,0,.87);
}
.createGroupStyle {
  background: #f3f3f3;padding: 10px; cursor: pointer;
}
.horizontal-scroll-wrapper {
  width: 100px;
  height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
  transform:rotate(-90deg) translateY(-100px);
  transform-origin: right top;
}

.horizontal-scroll-wrapper > div {
  width: 100px;
  height: 100px;
  transform: rotate(90deg);
  transform-origin: right top;
}
.okBTN {
  margin: 0 !important;
  font-weight: 600;
  /*margin-left: 15vw !important;*/
  float: right;
  font-size: 12px;
  /*background: #0000001c;*/
  box-shadow: none !important;
  border-radius: 20px;
  padding: 3px 10px;
  color: white;
  cursor: pointer;
}
.okBTN:hover {
    background: #0000001c;
}
.okBTNFalse {
  float: right;
  margin: 0 !important;
  font-weight: 600;
  /*margin-left: 15vw !important;*/
  font-size: 12px;
  box-shadow: none !important;
  border-radius: 20px;
  padding: 3px 10px;
  color: #e4e4e461;
  cursor: no-drop !important;
}
.colorHeader {
  margin-bottom: 5px !important;
    font-size: 12px;
    color: #2562af99;
}


.imageProfile {
  height: 50vw;
  width: 50vw;
  border-radius: 20px;
  cursor: pointer !important;
}
.image-upload>input {
  display: none;
}
.image-upload {
      display: inline-block;
    position: relative;
    border-radius: 20px;
    overflow: hidden;
    height: 50vw;
}
.alligator-turtle {
  object-fit: cover;
  object-position: 50% 0;
}
.SettingImgBtn {
    display: block;
    overflow: hidden;
    position: absolute;
    bottom: -20px;
    right: -20px;
    line-height: 1;
    width: 40px;
    height: 30px;
    bottom: 0;
    left: 0;
    line-height: 30px;
    width: 100%;
    text-align: center;
    cursor: pointer;
    color: #fff;
    background: rgba(0, 0, 0, .5);
}

.SettingImgBtn:hover {
    display: block;
    overflow: hidden;
    position: absolute;
    bottom: -20px;
    right: -20px;
    line-height: 1;
    width: 40px;
    height: 50%;
    bottom: 0;
    left: 0;
    line-height: 30px;
    width: 100%;
    text-align: center;
    cursor: pointer;
    color: #fff;
    background: rgba(0, 0, 0, .75);
}
</style>


// WEBPACK FOOTER //
// src/components/mail/Creategroup.vue